var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"preview-screen-bg",style:(_vm.rootStyle)},[_c('div',{staticClass:"screen",style:(_vm.screenStyle)})])}
var staticRenderFns = []

export { render, staticRenderFns }